import { IArtifactComponentProps } from "types/services";
import { IAgent, IPropertyId } from "types/artifacts/common";
import { IAgentDetailsArtifact } from "types/artifacts/agent-details";
import { AgentDetailCard } from "components/AgentDetailCard";
import { findArtifactByHarid } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IAgentDetailsOutputProps = IArtifactComponentProps<
    IPropertyId,
    IAgentDetailsArtifact
>;

AgentDetailsOutput.artifactKey = "property_detail";

export function AgentDetailsOutput(props: IAgentDetailsOutputProps): JSX.Element {
    const { harid, artifacts } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (harid) {
        const artifact = findArtifactByHarid(artifacts, harid);
        const realtor = artifact?.response?.realtor;
        const { artifact_text, ...remainingRealtor } = realtor || {};
        if (artifact && realtor) {
            return (
                <AgentDetailCard agent={remainingRealtor as IAgent} />
            );
        }

        console.error(
            "No artifact or realtor found for 'AgentDetailsOutput' with the given harid:",
            harid
        );

        return <></>;
    }

    console.error(
        "No harid provided for 'AgentDetailsOutput'."
    );

    return <></>;
}

AgentDetailsOutput.asText = function (props: IAgentDetailsOutputProps): string {
    // console.log("AgentDetailsOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.realtor?.artifact_text || "" : isProduction ? "" : "AgentDetailsOutput asText Not Implemented!";
}
